module.exports = __webpack_public_path__ + "img/202403_08.476bccda.jpg";